import PageMain from '@/components/page-main';
import { useEffect, useReducer, useState, useMemo } from 'react';
import useFetch from '@/hooks/useFetch';
import fetchValueReducer from '@/hooks/fetchValueReducer';
import { Table, Alert, Modal, message, Form, Radio, Space } from 'antd';
import { request } from '@/utils/request';
import { QAItem } from '../knowledge/components/productQA-item';
import Loading from '@/components/loading';
import { useAccess } from 'umi';
import useKnowledgeProduct from '@/pages/knowledge/hooks/useKnowledgeProduct';

const Index: React.FC = () => {
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 20, total: 1 });

  const { data, loading, fetchData } = useFetch("/local/chat/completion", { ...fetchValue }, dispatchFetchValue);
  const [id, setId] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [qas, setQAs] = useState<QAItem[]>([]);

  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const { data: productNames } = useKnowledgeProduct();

  const [form] = Form.useForm();

  const access = useAccess();

  useEffect(() => {
    if (id) {
      handleSave();
    }
  }, [id]);

  const activeCompletion: { product: string; productZh: string; }[] = useMemo(() => {
    if (!id) return [];
    const item = data.find((item: any) => item.id === id);
    if (!item || !item?.product) return [];
    return item.product.split(",").map((vo: string) => ({ product: vo, productZh: productNames.find(p => p.productName === vo)?.productZhName || vo }));
  }, [id]);

  useEffect(() => {
    if (activeCompletion.length > 0) {
      form.setFieldsValue({ selectedProduct: activeCompletion[0].product });
    }
  }, [activeCompletion])

  const clear = () => {
    setVisible(false);
    setId(0);
    setQAs([]);
    form.resetFields();
  }

  const handleSave = async (confirm = false) => {
    setPageLoading(true);
    const { selectedProduct } = form.getFieldsValue();
    const { resp, error } = await request('/local/knowledge/productQA/insert_by_completion', {
      method: 'POST',
      data: {
        id: id,
        confirm,
        selectedProduct: selectedProduct || "",
      }
    });
    setPageLoading(false);
    if (resp?.code !== 0) {
      return message.error(error?.message);
    }
    if (!resp?.data) {
      clear();
      return message.success(resp?.message);
    }
    setQAs(resp.data.list);
    setVisible(true);
  }


  const contentStyle = { fontSize: "12px", maxHeight: 150, overflowY: 'auto' } as React.CSSProperties;

  return <PageMain>
    <Table
      dataSource={data}
      columns={[
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Chat_ID', dataIndex: 'chat_id', key: 'chat_id' },
        {
          title: '客户输入',
          dataIndex: 'user_msg',
          key: 'user_msg',
          render: (_: any) => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="info"
          />
        },
        {
          title: 'GPT输出',
          dataIndex: 'gpt_response',
          key: 'gpt_response',
          render: (_: any) => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="success"
          />
        },
        {
          title: '提示词',
          dataIndex: 'chat_completion_prompt',
          key: 'chat_completion_prompt',
          render: (_: any) => {
            if (!_) return <>-</>;
            const content = JSON.stringify(JSON.parse(_), null, 4);
            return <Alert
              style={{
                whiteSpace: 'pre-wrap',
              }}
              description={<div style={contentStyle}>{content}</div>}
              type="warning"
            />
          }
        },
        { title: '创建时间', dataIndex: 'create_time', },
        {
          title: '操作',
          render: (_: any) => <a onClick={() => setId(_.id)}>保存至问答</a>
        }
      ].filter(vo => (access.productQAEdit ? true : vo.title !== '操作'))}
      loading={loading}
      rowKey="id"
      pagination={{
        showSizeChanger: true,
        current: fetchValue.page,
        total: fetchValue.total,
        pageSize: fetchValue.size,
        pageSizeOptions: [10, 20, 50],
        onChange: (page, size) => {
          dispatchFetchValue({ type: 'update', value: { page, size } });
          fetchData();
        },
      }}
    />

    <Modal
      visible={visible}
      title="保存至问答"
      width={700}
      onCancel={clear}
      okText="确定保存"
      onOk={() => handleSave(true)}
    >
      <Form form={form} layout="vertical">
        {
          activeCompletion.length > 0 ? <Form.Item label="选择对应的产品" name="selectedProduct">
            <Radio.Group size="small">
              {
                activeCompletion.map(vo => <Radio.Button value={vo.product}>{vo.productZh}</Radio.Button>)
              }
            </Radio.Group>
          </Form.Item> : <></>
        }
      </Form>
      <h3>存在以下相似问题：</h3>
      <Table
        dataSource={qas}
        columns={[
          { title: '问题', dataIndex: 'question', key: 'question', width: '50%' },
          { title: '答案', dataIndex: 'answer', key: 'answer', width: '50%' },
        ]}
        pagination={false}
      />
    </Modal>
    <Loading loading={pageLoading} />
  </PageMain>
}

export default Index;